var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2876_8540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 20C39 30.4934 30.4934 39 20 39C9.50659 39 1 30.4934 1 20C1 9.50659 9.50659 1 20 1C30.4934 1 39 9.50659 39 20Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5381 21.462L15.9109 28.0297C15.9109 28.0297 16.2076 28.6442 16.5253 28.6442C16.8429 28.6442 21.5678 23.7288 21.5678 23.7288L26.8219 13.5805L13.6228 19.7667L13.5381 21.462Z",
    fill: "#C8DAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6844 23.1464L16.2289 27.9874C16.2289 27.9874 16.0383 29.4707 17.5213 27.9874C19.0043 26.504 20.4238 25.3602 20.4238 25.3602",
    fill: "#A9C6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5811 21.6964L8.7001 20.106C8.7001 20.106 8.11677 19.8694 8.3046 19.3327C8.34327 19.222 8.42127 19.1279 8.6546 18.966C9.7361 18.2122 28.6723 11.406 28.6723 11.406C28.6723 11.406 29.2069 11.2259 29.5223 11.3457C29.6003 11.3698 29.6705 11.4143 29.7257 11.4745C29.7809 11.5346 29.8191 11.6084 29.8364 11.6882C29.8705 11.8291 29.8848 11.9741 29.8788 12.119C29.8773 12.2444 29.8621 12.3605 29.8506 12.5427C29.7353 14.4035 26.2839 28.2915 26.2839 28.2915C26.2839 28.2915 26.0774 29.1042 25.3376 29.132C25.1558 29.1379 24.9747 29.1071 24.805 29.0415C24.6353 28.9758 24.4806 28.8767 24.3501 28.75C22.8983 27.5012 17.8803 24.1289 16.7714 23.3872C16.7464 23.3702 16.7254 23.3479 16.7097 23.3221C16.694 23.2962 16.684 23.2672 16.6804 23.2372C16.6649 23.159 16.7499 23.0622 16.7499 23.0622C16.7499 23.0622 25.4876 15.2955 25.7201 14.4802C25.7381 14.417 25.6701 14.3859 25.5788 14.4135C24.9984 14.627 14.9381 20.9802 13.8278 21.6814C13.7478 21.7055 13.6634 21.7107 13.5811 21.6964Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2876_8540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgLogo);
export default __webpack_public_path__ + "static/media/tg_logo.1394f9cda0a6add69c6732757ebf7580.svg";
export { ForwardRef as ReactComponent };